exports.f = Object.getOwnPropertySymbols;



/*****************
 ** WEBPACK FOOTER
 ** ../~/core-js/modules/_object-gops.js
 ** module id = 2223
 ** module chunks = 3
 **/